<ion-header mode="ios" class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/tabs/home" text=""></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-content__subpage">
  <div class="impact-item__label" *ngIf="story?.engagement_campaign">
    {{ 'INSIGHTS.impact.engagement.category' | translate }}
    <img src="../../../../assets/icon/engagement.svg" />
  </div>
  <div class="impact-item__header">
    <p>{{ story?.publish_date | dateTranslate: 'shortDate' : language }}</p>
    <h1 [innerHTML]="story?.title"></h1>
  </div>
  <div class="impact-item__image" [ngStyle]="{ backgroundImage: 'url(' + story?.image + ')' }">
    <div *ngIf="story?.company_image" class="impact-item__image-logo">
      <img [src]="story?.company_image" />
    </div>
  </div>
  <div class="impact-item__content">
    <p *ngIf="!loading" [innerHTML]="story?.content" (click)="onArticleClicked($event)"></p>
    <p *ngIf="loading"><ion-skeleton-text animated></ion-skeleton-text></p>
    <p *ngIf="loading"><ion-skeleton-text animated></ion-skeleton-text></p>
  </div>
  <div class="impact-item__footer impact-item__footer--cta" slot="fixed" *ngIf="story?.cta && engagementCampaignActive">
    <ion-button mode="ios" expand="block" class="impact-item__content-cta" (click)="openArticle(story?.link, true)">
      {{ 'SHARED.actions.registerWebinar' | translate }}
    </ion-button>
  </div>
  <div class="impact-item__footer" slot="fixed" *ngIf="!story?.cta && story?.link" (click)="openArticle(story?.link, false)">
    <span>{{ 'SHARED.actions.readMore' | translate }}</span>
    <ion-icon name="open-outline"></ion-icon>
  </div>
  <app-ds-feedback-loop
    feedbackSource="ImpactNews-{{ id }}"
    [ngClass]="{ 'extra-margin': !story?.cta && story?.link }"
    (trackFeedback)="track($event)"
  >
    {{ 'feedbackLoopWidget.title' | translate }}
  </app-ds-feedback-loop>
</ion-content>
